// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"e641f472","321":"f68d7a40","453":"a8cabccd","458":"cf014cdf","699":"1ba65ca7","772":"8ff4d2f2","788":"87505df6","818":"041f8746"}[chunkId] + ".chunk.js";
};